import DialogBase, { DialogBaseProps } from './DialogBase'
import { Box } from '@mui/material'
import { useForm } from 'react-hook-form'
import RhfSelect from '../../rhf-mui/RhfSelect'
import { useState } from 'react'

export type SelectDialogBaseProps = DialogBaseProps & {
  width?: string;
  options?: any[];
  displayMember?: string;
  valueMember?: string;

}

const SelectDialogBase = ({
  title,
  width,
  valueMember, // 將 valueMember 從 props 中解構出來
  displayMember, // 將 displayMember 從 props 中解構出來


  ...props }: SelectDialogBaseProps) => {

  const rhf = useForm();
  const DEFAULT_INPUT_WIDTH = "300px";

  let input_attr = { label: title, InputLabelProps: { shrink: true } }
  const options = props.options;
  return (
    <DialogBase
      dialogContentProps={{ dividers: true }}

      content={
        <Box sx={{ maxHeight: '800px' }}>
          <RhfSelect rhf={rhf} name={valueMember} size="medium" options={options}
            valueMember={valueMember} displayMember={displayMember}
            value= {valueMember}
            sx={{ width: width === "" ? DEFAULT_INPUT_WIDTH : width, }}
            {...input_attr} />
        </Box>
      }

      {...props}
      onDialogResult={(e) => {// 注意! 要放在 ...props 後面覆寫事件
        const value = valueMember === undefined ? ""  : valueMember;
        const getvalue = rhf.getValues(value);
        const re = options?.find(x => x[value] === getvalue);
        e.Data = re;
        props.onDialogResult?.(e);
      }}
    />
  )
}


export default SelectDialogBase